import { useTranslation } from 'react-i18next';
import { useState } from "react";

const Aspectos = ({ lang, faqs, config, ruta }) => {

    let { t } = useTranslation();

    const [activeTabCat, setActiveTabCat] = useState("essential");

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";



    const [faqOpen, setFaqOpen] = useState(null);

    function getArrayCookie(nombre) {
        let nombreCookie = `${nombre}=`;
        let cookiesDecodificadas = decodeURIComponent(document.cookie);
        let arrayCookies = cookiesDecodificadas.split(';');

        for (let i = 0; i < arrayCookies.length; i++) {
            let cookie = arrayCookies[i].trim();
            if (cookie.indexOf(nombreCookie) === 0) {
                try {
                    return JSON.parse(cookie.substring(nombreCookie.length, cookie.length));
                } catch (e) {
                    console.error('Error parseando cookie:', e);
                    return null;
                }
            }
        }
        return null;
    }

    const cookieValue = getArrayCookie("datos");


    return (
        <>
            <c-anchors _nghost-ng-c2642101700="">
                <div _ngcontent-ng-c2642101700="" init="false" className="c-rw-swiper-anchors" style={{ display: "flex" }}>
                    <div _ngcontent-ng-c2642101700="" className="active swiper-slide-active" role="group" aria-label="1 / 5">
                        <a href="#benefits0" style={{ cursor: "pointer" }}>{t("BENEFICIOS")}</a>
                    </div>
                    <div _ngcontent-ng-c2642101700="" role="group" aria-label="2 / 5" className="swiper-slide-next">
                        <a href="#categories" style={{ cursor: "pointer" }}>{t("CATEGORÍAS")}</a>
                    </div>
                    <div _ngcontent-ng-c2642101700="" role="group" aria-label="3 / 5">
                        <a href="#points" style={{ cursor: "pointer" }}>{t("PUNTOS")}</a>
                    </div>
                    <div _ngcontent-ng-c2642101700="" role="group" aria-label="4 / 5">
                        <a href="#giving" style={{ cursor: "pointer" }}>{t("INSPÍRATE")}</a>
                    </div>
                    <div _ngcontent-ng-c2642101700="" role="group" aria-label="5 / 5">
                        <a href="#faqs" style={{ cursor: "pointer" }}>{t("PREGUNTAS FRECUENTES")}</a>
                    </div>
                </div>
            </c-anchors>
            <div className="container rw-container">
                <h1>
                    <p>{t("TE DAMOS LA BIENVENIDA A")} </p>
                    <p>
                        <span style={{ color: "rgb(150, 113, 38)" }}>{t("VALE REWARD")}</span>
                    </p>
                </h1>
            </div>
            <reward-public-welcome-images>
                <div init="false" className="c-rw-swiper-img-card" style={{ display: "flex" }}>
                    <div className="first-slide swiper-slide-active" role="group" aria-label="1 / 3" style={{ marginRight: "18px" }}>
                        <figure className="img">
                            {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APub_5.jpg" alt="" />*/}
                            <img loading="lazy" src="/images/web/valesuites/rewards1.png" alt="" />
                        </figure>
                    </div>
                    <div role="group" aria-label="2 / 3" className="swiper-slide-next" style={{ marginRight: "18px" }}>
                        <figure className="img">
                            {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T4D3/H10Rewards_APub_4.jpg" alt="" />*/}
                            <img loading="lazy" src="/images/web/valesuites/rewards2.png" alt="" />
                        </figure>
                    </div>
                    <div className="last-slide" role="group" aria-label="3 / 3">
                        <figure className="img">
                            {/*<img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APub_2.jpg" alt="" />*/}
                            <img loading="lazy" src="/images/web/valesuites/rewards3.png" alt="" />
                        </figure>
                    </div>
                </div>

            </reward-public-welcome-images>
            <div className="container rw-container mb-md-100" id="benefits0">
                <p className="rw-subtitle text-up-md">
                    {t("Con el programa de fidelización Vale Rewards premiamos tu fidelidad. Alójate en nuestros alojamientos y disfruta de beneficios exclusivos y atenciones especiales. Suma puntos y canjéalos por noches de estancia y servicios. Prepárate para que tus viajes no tengan límites.")}
                </p>
            </div>
            <reward-benefits id="benefits" >
                <div className="container">
                    <h2 className="mb-5">{t("BENEFICIOS")}</h2>
                    <div className="mb-6">
                        <ul className="o-rw-list o-rw-list-features">
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_DESCUENTO_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("5% de descuento garantizado")}</strong> {t("Disfruta de mínimo un 5% de descuento en todas las reservas en nuestra web")} </span>
                            </li>
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_NOCHE_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Noches y servicios gratuitos")}</strong> {t("Acumula puntos y canjéalos por estancias")} </span>
                            </li>
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_REGALO_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Obsequios y atenciones únicas")}</strong> {t("Siéntete especial durante tu estancia")} </span>
                            </li>
                            <li className="col-md-6 col-xl-3">
                                <figure>
                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_PRIMIUM_Negro.svg" />
                                </figure>
                                <span>
                                    <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Promociones y descuentos exclusivos")}</strong> {t("Accede a ofertas solo para socios y reserva con las mejores condiciones")} </span>
                            </li>

                        </ul>
                        <div className="collapse">
                            <ul className="o-rw-list o-rw-list-features">
                                <li className="col-md-6 col-xl-3">
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_PUNTOS_Negro.svg" />
                                    </figure>
                                    <span>
                                        <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Puntos de bienvenida")}</strong> {t("Obtén 100 puntos al unirte a Vale Rewards")}</span>
                                </li>
                                <li className="col-md-6 col-xl-3">
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_TARJETA_Negro.svg" />
                                    </figure>
                                    <span>
                                        <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Paga con puntos")}</strong> {t("Reserva y paga tu estancia combinando dinero y puntos")} </span>
                                </li>
                                <li className="col-md-6 col-xl-3">
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_CENA_Negro.svg" />
                                    </figure>
                                    <span>
                                        <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Restaurantes y bares")}</strong> {t("Descuentos en la mejor gastronomía. Consigue y canjea puntos en nuestros restaurantes y bares")} </span>
                                </li>
                                <li className="col-md-6 col-xl-3">
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_SPA_Negro.svg" />
                                    </figure>
                                    <span>
                                        <strong className="rewards-color mb-md-3 text-up-md d-block">{t("Despacio Spa Centres")}</strong> {t("Relájate y desconecta en nuestros Spas. Acumula y redime puntos en todos los servicios")} </span>
                                </li>

                            </ul>
                        </div>
                        {/* <button type="button" aria-controls="collapseExample" className="mx-auto btn btn-link btn-rw-link d-flex" aria-expanded="false">
                            <span>{t("VER MÁS")}</span>
                        </button> */}

                    </div>
                </div>
            </reward-benefits>

            <reward-public-categories id="categories">
                <div className="container rw-container">
                    <h2 className="mb-2 mb-md-1">{t("CATEGORÍAS")}</h2>
                    <p className="rw-subtitle text-md rewards-color">{t("Eleva tu experiencia con cada una de las cuatro categorías")}</p>
                </div>
                <div className="container mt-5 mb-4 rw-container rw-tab-categorias">
                    <div ngbnav="" className="nav" role="tablist">
                        <div className="nav-item" role="presentation">
                            <button type="button" ngbnavlink="" className={`nav-link essential  ${activeTabCat === "essential" ? ' active' : ''}`} id="ngb-nav-0" role="tab" aria-controls="ngb-nav-0-panel" aria-selected="true" aria-disabled="false" onClick={() => setActiveTabCat("essential")}>
                                <span className="o-rw-title-category">
                                    <span>{t("ESSENTIAL")}</span>
                                </span>
                                <br />
                                <span className="d-none d-md-block">{t("DESDE EL PRIMER DÍA")}</span>
                            </button>

                        </div>
                        <div className="nav-item" role="presentation">
                            <button type="button" ngbnavlink="" className={`nav-link silver ${activeTabCat === "silver" ? ' active' : ''}`} id="ngb-nav-1" role="tab" tabIndex="-1" aria-selected="false" aria-disabled="false" onClick={() => setActiveTabCat("silver")}>
                                <span className="o-rw-title-category">
                                    <span>{t("SILVER")}</span>
                                </span>
                                <br />
                                <span className="d-none d-md-block">{t("A PARTIR DE 5 NOCHES O 3 ESTANCIAS")}</span>
                            </button>

                        </div>
                        <div className="nav-item" role="presentation">
                            <button type="button" ngbnavlink="" className={`nav-link gold ${activeTabCat === "gold" ? ' active' : ''}`} id="ngb-nav-2" role="tab" tabIndex="-1" aria-selected="false" aria-disabled="false" onClick={() => setActiveTabCat("gold")}>
                                <span className="o-rw-title-category">
                                    <span>{t("GOLD")}</span>
                                </span>
                                <br />
                                <span className="d-none d-md-block">{t("A PARTIR DE 25 NOCHES O 15 ESTANCIAS")}</span>
                            </button>

                        </div>
                        <div className="nav-item" role="presentation">
                            <button type="button" ngbnavlink="" className={`nav-link platinum ${activeTabCat === "platinum" ? ' active' : ''}`} id="ngb-nav-3" role="tab" tabIndex="-1" aria-selected="false" aria-disabled="false" onClick={() => setActiveTabCat("platinum")}>
                                <span className="o-rw-title-category">
                                    <span>{t("PLATINUM")}</span>
                                </span>
                                <br />
                                <span className="d-none d-md-block">{t("A PARTIR DE 40 NOCHES O 25 ESTANCIAS")}</span>
                            </button>

                        </div>

                    </div>
                    <div className="tab-content">
                        <div ngbnavpane="" className={`tab-pane fade  ${activeTabCat === "essential" ? ' active show' : ''}`} id="ngb-nav-0-panel" role="tabpanel" aria-labelledby="ngb-nav-0">
                            <div className="rw-tab-categorias_item essential">
                                <div className="rw-tab-categorias_item-txt">
                                    <img loading="lazy" alt="" className="background" src="https://pro-static.h10hotels.com/templates/H10/src/images/mask-logo.png" />
                                    <span className="o-rw-title-category d-md-none">
                                        <span className="mb-1">{t("ESSENTIAL")}</span> {t("DESDE EL PRIMER DÍA")} </span>
                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/icon-check.png" />{t("VENTAJAS")}
                                    </p>
                                    <ul>
                                        <li>{t("Obsequio de bienvenida")}</li>
                                        <li>{t("Botella de agua de cortesía")}</li>
                                        <li>{t("Regalo de cumpleaños Vale Rewards")}</li>

                                    </ul>

                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/small-percent.svg" /> {t("DESCUENTOS")}
                                    </p>
                                    <ul>
                                        <li>{t("5% de dto. garantizado en todas las reservas realizadas en nuestra web")}</li>

                                    </ul>

                                </div>

                                <div className="rw-tab-categorias_item-img d-none d-md-block">
                                    <figure>
                                        {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APub_ESSENTIAL.jpg" alt="" />*/}
                                        <img loading="lazy" src="/images/web/valesuites/essential.png" alt="" />
                                    </figure>
                                </div>



                            </div>

                        </div>

                        <div ngbnavpane="" className={`tab-pane fade  ${activeTabCat === "silver" ? ' active show' : ''}`} id="ngb-nav-11-panel" role="tabpanel" aria-labelledby="ngb-nav-11">
                            <div className="rw-tab-categorias_item silver">
                                <div className="rw-tab-categorias_item-txt">
                                    <img loading="lazy" alt="" className="background" src="https://pro-static.h10hotels.com/templates/H10/src/images/mask-logo.png" />
                                    <span className="o-rw-title-category d-md-none">
                                        <span className="mb-1">{t("SILVER")}</span> {t("A PARTIR DE 5 NOCHES O 3 ESTANCIAS")} </span>
                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/icon-check.png" /> {t("VENTAJAS")}
                                    </p>
                                    <ul>
                                        <li>{t("Obsequio de bienvenida")}</li>
                                        <li>{t("Botella de agua de cortesía")}</li>
                                        <li>{t("Regalo de cumpleaños Vale Rewards")}</li>
                                        <li>{t("Cóctel o refresco para dos personas")}</li>

                                    </ul>

                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/small-percent.svg" />{t("DESCUENTOS")}
                                    </p>
                                    <ul>
                                        <li>{t("5% de dto. garantizado en todas las reservas realizadas en nuestra web")}</li>
                                        <li>{t("5% de dto. en bares y restaurantes a la carta (sujeto a términos y condiciones)")}</li>
                                        <li>{t("5% de dto. en circuitos de agua y masajes en nuestros Despacio Spa Centres")}</li>

                                    </ul>

                                </div>

                                <div className="rw-tab-categorias_item-img d-none d-md-block">
                                    <figure>
                                        {/*}img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APub_SILVER.jpg" alt="" />*/}
                                        <img loading="lazy" src="/images/web/valesuites/silver.png" alt="" />
                                    </figure>
                                </div>



                            </div>

                        </div>

                        <div ngbnavpane="" className={`tab-pane fade  ${activeTabCat === "gold" ? ' active show' : ''}`} id="ngb-nav-12-panel" role="tabpanel" aria-labelledby="ngb-nav-12">
                            <div className="rw-tab-categorias_item gold">

                                <div className="rw-tab-categorias_item-img d-none d-md-block">
                                    <figure>
                                        {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APub_GOLD.jpg" alt="" />*/}
                                        <img loading="lazy" src="/images/web/valesuites/gold.png" alt="" />
                                    </figure>
                                </div>

                                <div className="rw-tab-categorias_item-txt">
                                    <img loading="lazy" alt="" className="background" src="https://pro-static.h10hotels.com/templates/H10/src/images/mask-logo.png" />
                                    <span className="o-rw-title-category d-md-none">
                                        <span className="mb-1">{t("GOLD")}</span> {t("A PARTIR DE 25 NOCHES O 15 ESTANCIAS")} </span>
                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/icon-check.png" /> {t("VENTAJAS")}
                                    </p>
                                    <ul>
                                        <li>{t("Obsequio de bienvenida")}</li>
                                        <li>{t("Botella de agua de cortesía")}</li>
                                        <li>{t("Regalo de cumpleaños Vale Rewards")}</li>
                                        <li>{t("Botella de cava o vino de regalo")}</li>
                                        <li>{t("Late check-out (bajo disponibilidad)*")}</li>
                                        <li>{t("Check-in Preferente")}</li>
                                        <li>{t("Descubierta de cama diaria (bajo disponibilidad)")}</li>
                                        <li>{t("Albornoz y zapatillas")} </li>

                                    </ul>

                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/small-percent.svg" /> {t("DESCUENTOS")}
                                    </p>
                                    <ul>
                                        <li>{t("7% de dto. garantizado en todas las reservas realizadas en nuestra web")}</li>
                                        <li>{t("10% de dto. en bares y restaurantes a la carta (sujeto a términos y condiciones)")}</li>
                                        <li>{t("10% de dto. en circuitos de agua y masajes en nuestros Despacio Spa Centres")}</li>

                                    </ul>

                                </div>


                            </div>

                        </div>

                        <div ngbnavpane="" className={`tab-pane fade  ${activeTabCat === "platinum" ? ' active show' : ''}`} id="ngb-nav-13-panel" role="tabpanel" aria-labelledby="ngb-nav-13">
                            <div className="rw-tab-categorias_item platinum">

                                <div className="rw-tab-categorias_item-img d-none d-md-block">
                                    <figure>
                                        {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APub_PLATINUM.jpg" alt="" />*/}
                                        <img loading="lazy" src="/images/web/valesuites/platimun.png" alt="" />
                                    </figure>
                                </div>

                                <div className="rw-tab-categorias_item-txt">
                                    <img loading="lazy" alt="" className="background" src="https://pro-static.h10hotels.com/templates/H10/src/images/mask-logo.png" />
                                    <span className="o-rw-title-category d-md-none">
                                        <span className="mb-1">{t("PLATINUM")}</span> {t("A PARTIR DE 40 NOCHES O 25 ESTANCIAS")}</span>
                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/icon-check.png" /> {t("VENTAJAS")}
                                    </p>
                                    <ul>
                                        <li>{t("Obsequio de bienvenida")}</li>
                                        <li>{t("Botella de agua de cortesía")}</li>
                                        <li>{t("Regalo de cumpleaños Vale Rewards")}</li>
                                        <li>{t("Late check-out (bajo disponibilidad)*")}</li>
                                        <li>{t("Check-in Preferente")}</li>
                                        <li>{t("Upgrade de habitación (bajo disponibilidad en el momento del check-in)*")}</li>
                                        <li>{t("Almuerzo o cena para dos personas en alojamiento de vacacional")}</li>
                                        <li>{t("Botella de vino o cava y snack en alojamiento urbano")}</li>
                                        <li>{t("Descubierta de cama diaria (bajo disponibilidad)")}</li>
                                        <li>{t("Albornoz y zapatillas ")}</li>
                                        <li>{t("Kettle de tés ")}</li>

                                    </ul>

                                    <p className="title">
                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/small-percent.svg" /> {t("DESCUENTOS")}
                                    </p>
                                    <ul>
                                        <li>{t("7% de dto. garantizado en todas las reservas realizadas en nuestra web")}</li>
                                        <li>{t("15% de dto. en bares y restaurantes a la carta (sujeto a términos y condiciones)")}</li>
                                        <li>{t("15% de dto. en circuitos de agua y masajes en nuestros Despacio Spa Centres")}</li>

                                    </ul>

                                </div>


                            </div>

                        </div>







                    </div>
                </div>
            </reward-public-categories>

            <div id="points" className="container rw-container">
                <h2 className="mb-1 mb-md-2">{t("PUNTOS")}</h2>
                <p className="rw-subtitle text-md rewards-color">{t("Obtén puntos y canjéalos por estancias")}</p>
            </div>

            <reward-public-points>
                <div className="mt-6 c-rw-banner">
                    <figure className="c-rw-banner_back">
                        <img loading="lazy" alt="" src="https://pro-static.h10hotels.com/templates/H10/src/images/img-banner.jpg" />
                    </figure>
                    <div className="container rw-container">
                        <div className="o-title-btn">
                            <h3>
                                <p className="ql-align-center">{t("¿CÓMO OBTENGO")} <span style={{ color: "rgb(150, 113, 38)" }}>{t("PUNTOS?")}</span>
                                </p>
                            </h3>
                            <i className="fa-solid fa-chevron-down"></i>
                            <button type="button" aria-controls="collapseExample" className="btn btn-collapse" aria-expanded="true">
                                <span className="visually-hidden show d-md-none"> {t("Mostrar información")} </span>
                                <span className="visually-hidden hide d-md-none"> {t("Ocultar información")} </span>
                            </button>
                        </div>
                        <div className="collapse show">
                            <div className="c-rw-banner_txt-big">
                                <p className="ql-align-center">{t("Obtén puntos en cada nueva reserva que realices o al consumir en los distintos servicios que te ofrecemos en nuestros alojamientos. En función de tu categoría Vale Rewards, la cantidad de puntos obtenidos será distinta.")}</p>
                                <p className="ql-align-center">
                                    <br />
                                </p>
                                <p className="ql-align-center">ESSENTIAL <span style={{ color: "rgb(150, 113, 38)" }}>|</span> {t("Por cada 1€ de gasto acumulas 1,05 puntos")} </p>
                                <p className="ql-align-center">SILVER <span style={{ color: "rgb(150, 113, 38)" }}>|</span> {t("Por cada 1€ de gasto acumulas 1,10 puntos")} </p>
                                <p className="ql-align-center">GOLD <span style={{ color: "rgb(150, 113, 38)" }}>|</span> {t("Por cada 1€ de gasto acumulas 1,16 puntos")} </p>
                                <p className="ql-align-center">PLATINUM <span style={{ color: "rgb(150, 113, 38)" }}>|</span> {t("Por cada 1€ de gasto acumulas 1,21 puntos")} </p>
                            </div>
                            <p className="text-xs">{t("Los puntos obtenidos hacen referencia a reservas realizadas a través de nuestras webs o call center.")}</p>
                        </div>
                        <div className="o-title-btn">
                            <h3>
                                <p className="ql-align-center">{t("¿CÓMO PUEDO UTILIZAR")} <span style={{ color: "rgb(150, 113, 38)" }}>{t("MIS PUNTOS?")}</span>
                                </p>
                            </h3>
                            <i className="fa-solid fa-chevron-down"></i>
                            <button type="button" aria-controls="collapseExample" className="btn btn-collapse" aria-expanded="true">
                                <span className="visually-hidden show d-md-none"> {t("Mostrar información")} </span>
                                <span className="visually-hidden hide d-md-none"> {t("Ocultar información")} </span>
                            </button>
                        </div>
                        <div className="collapse show">
                            <ul className="o-rw-list o-rw-list-features">
                                <li>
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10RW_Icono_Luna.svg" alt="" />
                                    </figure>
                                    <span>
                                        <p>{t("Noches gratis y descuento")}</p>
                                    </span>
                                </li>
                                <li>
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10RW_Icono_Restaurante.svg" alt="" />
                                    </figure>
                                    <span>
                                        <p>{t("Disfrutar de la mejor gastronomía en nuestros restaurantes y bares")}</p>
                                    </span>
                                </li>
                                <li>
                                    <figure>
                                        <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10RW_Icono_Spa.svg" alt="" />
                                    </figure>
                                    <span>
                                        <p>{t("Una pausa para tu bienestar donde relajarte en nuestros Despacio Spa Centres")}</p>
                                    </span>
                                </li>

                            </ul>
                        </div>

                    </div>
                </div>
            </reward-public-points>

            <div id="giving" className="container mb-5 rw-container mb-md-80">
                <figure>
                    {
                        config.logo !== "" ?
                            <img loading="lazy" className="mx-auto mb-5 d-flex img-small-mov" src={ruta + "/web/logo/web/" + config.logo} style={{ maxWidth: "200px" }} />
                            :
                            config.logo_fiscal != "" ?
                                <img loading="lazy" className="mx-auto mb-5 d-flex img-small-mov" src={ruta + "/web/logo/" + config.logo_fiscal} style={{ maxWidth: "200px" }} />
                                :
                                <img loading="lazy" className="mx-auto mb-5 d-flex img-small-mov" src="https://www.bedloop.com/imatges/logo.webp" style={{ maxWidth: "200px" }} />
                    }
                </figure>
                <h2 className="mb-3">
                    <p>{t("DESTINOS PARA")}</p>
                    <p>
                        <span style={{ color: "rgb(150, 113, 38)" }}>{t("DISFRUTAR")}</span> {t("DE VALE REWARDS")}
                    </p>
                </h2>
                <p className="text-sm rw-subtitle">
                    {t("Vale Rewards te permite disfrutar de todas las ventajas de formar parte de nuestro programa de fidelización en todos nuestros añojamientos. Tu próxima reserva con descuentos exclusivos te está esperando.")}
                </p>
                <a className="mx-auto btn rw-btn btn-rewards d-flex w-fit" target="_blank" href={`/${preidioma}${t("buscar")}`} style={{ borderRadius: "2.6em" }}>{t("ENCUENTRA TU ALOJAMIENTO")}</a>
            </div>

            <reward-public-loyalty-images>
                <div className="bg-rewards-light c-cont-swiper-img">
                    <div className="container rw-container">
                        <figure>
                            {
                                config.logo !== "" ?
                                    <img loading="lazy" alt="" className="mx-auto d-flex logo mb-md-6 pt-md-5" src={ruta + "/web/logo/web/" + config.logo} />
                                    :
                                    config.logo_fiscal != "" ?
                                        <img loading="lazy" alt="" className="mx-auto d-flex logo mb-md-6 pt-md-5" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                        :
                                        <img loading="lazy" alt="" className="mx-auto d-flex logo mb-md-6 pt-md-5" src="https://www.bedloop.com/imatges/logo.webp" />
                            }
                        </figure>
                        <h2>
                            <p>{t("ÚNETE A ")}<span style={{ color: "rgb(150, 113, 38)" }}>VALE REWARDS</span>
                            </p>
                            <p>{t("¡TE REGALAMOS 100 PUNTOS DE BIENVENIDA!")}</p>
                        </h2>
                        <div className="flex-wrap gap-3 mt-8 d-flex align-items-center justify-content-center gap-md-5">

                            {!cookieValue ?
                                <button id="openLogin" className="btn rw-btn btn-rewards" style={{ borderRadius: "2.6em" }}>{t("QUIERO UNIRME")}</button>
                                :
                                ""
                            }

                        </div>
                    </div>
                    <div init="false" className="mt-5 c-rw-swiper-imgs" style={{ display: "flex" }}>
                        <div style={{ width: "470.5px", marginRight: "5px" }} role="group" aria-label="1 / 4" className="swiper-slide-active">
                            <figure className="img">
                                {/*<img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APub_FOOTER1.jpg" alt="" />*/}
                                <img loading="lazy" src="/images/web/valesuites/footer-rewards1.png" alt="" />
                            </figure>
                        </div>
                        <div style={{ width: "470.5px", marginRight: "5px" }} role="group" aria-label="2 / 4" className="swiper-slide-next">
                            <figure className="img">
                                {/*<img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APub_FOOTER2.jpg" alt="" />*/}
                                <img loading="lazy" src="/images/web/valesuites/footer-rewards2.png" alt="" />
                            </figure>
                        </div>
                        <div style={{ width: "470.5px", marginRight: "5px" }} role="group" aria-label="3 / 4">
                            <figure className="img">
                                {/*<img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APub_FOOTER4.jpg" alt="" />*/}
                                <img loading="lazy" src="/images/web/valesuites/footer-rewards3.png" alt="" />
                            </figure>
                        </div>
                        <div style={{ width: "470.5px" }} role="group" aria-label="4 / 4">
                            <figure className="img">
                                {/*<img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APub_FOOTER3.jpg" alt="" />*/}
                                <img loading="lazy" src="/images/web/valesuites/footer-rewards4.png" alt="" />
                            </figure>
                        </div>

                    </div>
                    <div className="o-rw-senefa"></div>
                </div>
            </reward-public-loyalty-images>

            <div id="faqs" className="container mt-5 rw-container o-rw-title-logo">

                <h2>{t("PREGUNTAS FRECUENTES")}</h2>
                <reward-faq>
                    <div ngbaccordion="" className="mb-5 accordion c-rw-accordion">

                        {faqs.map((faq, index) => (

                            <div className="accordion-item" id={faq.id} key={faq.id}>
                                <div role="heading" ngbaccordionheader="" className={`accordion-header ${faqOpen != faq.id ? 'collapsed' : ''}`}>
                                    <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id={`${faq.id}-toggle`} aria-controls={`${faq.id}-collapse`} aria-expanded={faqOpen == faq.id} onClick={() => setFaqOpen(faqOpen === faq.id ? mull : 0)}>
                                        <p>{faq.pregunta[lang]}</p>
                                    </button>
                                </div>
                                <div role="region" ngbaccordioncollapse="" className={`accordion-collapse collapse ${faqOpen == faq.id ? 'show' : ''}`} id={`${faq.id}-collapse`} aria-labelledby={`${faq.id}-toggle`}>
                                    <div ngbaccordionbody="" className="accordion-body" dangerouslySetInnerHTML={{ __html: faq.respuesta[lang] }}>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </reward-faq>
            </div>
        </>
    );
}

export default Aspectos;
